import React from 'react'
import CuratedFeedList from '@/components/curated-feed/CuratedFeedList'
import { PageContainer } from '@/components/layout/PageContainer'

const NewsPage: React.FC = () => {
  return (
    <PageContainer maxWidth="7xl">
      <header className="mb-4">
        <h1 className="text-xl font-semibold text-gray-900">News</h1>
        <p className="text-sm text-gray-500">Curated articles on leadership, career growth, and mentorship.</p>
      </header>

      <CuratedFeedList />
    </PageContainer>
  )
}

export default NewsPage
